var THREE         = require("three");
var Handle3dView  = require("./../../../abstract/handle3dView.js");
var lib_core      = require("lib-core");

var RadialHandleView = function (model, editorView, handleId, config) {
    Handle3dView.call(this, model, editorView, handleId);

    var self = this;
    this.config = config;

    this.extraRadius = (this.config.extraRadius) ? this.config.extraRadius : 0;
    this.handleMesh = null;

    this.material = new THREE.MeshBasicMaterial( {
        color: this.config.color,
        side: THREE.DoubleSide,
        transparent: (this.config.opactiy == 1)?false: true,
        opacity: this.config.opacity
    } );

    this.lastRadius = null;
    this.lastPosition = null;
    this.lastRotation = null;

    this.model.subjects.onBubble({}, function(){
        self.subjectsChanged(this);
    });
}

lib_core.inherit(RadialHandleView, Handle3dView);

RadialHandleView.prototype.subjectsChanged = function(subjects){
   
    if(subjects.size() == 0){
        this.destroy();
        return;
    } 

    var radius = this.model.getSubjectsRadius();
    var position = this.model.getSubjectsCenter();
    var rotation = this.model.getSubjectsRotation();

    // only rebuild if radius changed
    if(radius != this.lastRadius || this.handleMesh == null){
        this.destroy();
        this.handleMesh = this.buildMesh(radius);
        this.editorView.rootGroup.add(this.handleMesh);
        this.editorView.addMeshToSelectableList(this.handleMesh, this.model, true);
        this.repositionMesh(this.handleMesh, position, rotation);
    }

    // only move if position or radius has changed
    if(!this.lastPosition || !position.eq(this.lastPosition) || !this.lastRotation || !rotation.eq(this.lastRotation)){
        this.repositionMesh(this.handleMesh, position, rotation);
    }

    this.lastRadius = radius;
    this.lastPosition = position.copy();
    this.lastRotation = rotation.copy();

    this.editorView.render();
}

RadialHandleView.prototype.repositionMesh = function(mesh, position){
    console.error("not implimented");
}

RadialHandleView.prototype.hoverChanged = function(){
    console.error("not implimented");
} 


RadialHandleView.prototype.buildMesh = function(radius){
    console.error("not implimented");
}


RadialHandleView.prototype.destroy = function(){
    if(this.handleMesh != null){
        this.editorView.removeMeshFromSelectableList(this.handleMesh);
        this.editorView.rootGroup.remove(this.handleMesh);
        this.editorView.destroyObject(this.handleMesh);
        this.handleMesh = null;
    }
}



module.exports = RadialHandleView;
